import { useEffect, useRef } from 'react';
import type { LoginVerifyContactResponse } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc';
import { useLoginVerify } from './useLoginVerify';
import { redirectToLogin } from '../utils/loginRedirect';

export type UsePortalsAuthOptions = {
  redirectUrl?: string;
};

export type UsePortalsAuthResult = {
  isLoading: boolean;
  isAccessDenied: boolean;
  user: LoginVerifyContactResponse | undefined;
};

export function usePortalsAuth(
  options?: UsePortalsAuthOptions
): UsePortalsAuthResult {
  const { data: user, loading } = useLoginVerify();

  const isAccessDenied =
    !loading && !!user && user.requestedInstanceAccess === 'DENIED';
  const hasRedirectedRef = useRef(false);

  useEffect(() => {
    if (!loading && !user && !hasRedirectedRef.current) {
      hasRedirectedRef.current = true;
      redirectToLogin(options?.redirectUrl);
    }
  }, [loading, user, options?.redirectUrl]);

  return { isLoading: loading, isAccessDenied, user };
}
